export const LANDING_NEW_SLIDER = 'landing_new_slider'
